import { createFileRoute, redirect } from '@tanstack/react-router'

/**
 * `/newsletters` — the archive's old URL, kept for bookmarks. Newsletters is a Market page now
 * (`/market/newsletters`); the loader always redirects there, so `component` never renders on a
 * real visit, and a replace keeps the dead URL out of the back stack. See `IssuesRedirect.tsx`.
 */
export const Route = createFileRoute('/_app/newsletters')({
  loader: () => {
    // eslint-disable-next-line @typescript-eslint/only-throw-error
    throw redirect({ to: '/market/newsletters', replace: true })
  },
  component: () => null,
})
